export default {
  getFleetSupplier: (state) => state.fleetSupplier,
};
